import type { ModuleRoute } from './types';
import { routes as sitesRoutes } from './sites/routes';
import { routes as membersRoutes } from './members/routes';
import { routes as fieldsNoticesRoutes } from './fields-notices/routes';
import { routes as todayRoutes } from './today/routes';
import { routes as devicesRoutes } from './devices/routes';
import { routes as badgesRoutes } from './badges/routes';
import { routes as agreementsRoutes } from './agreements/routes';
// Phase 2 (docs/PHASE-2-PLAN.md)
import { routes as notificationsRoutes } from './notifications/routes';
import { routes as preregistrationRoutes } from './preregistration/routes';
import { routes as reportsRoutes } from './reports/routes';
import { routes as publicLinksRoutes } from './public-links/routes';
import { routes as peopleRoutes } from './people/routes';
// Phase 3 (docs/PHASE-3-PLAN.md)
import { routes as evacuationRoutes } from './evacuation/routes';
import { routes as safetyRoutes } from './safety/routes';
import { routes as permitsRoutes } from './permits/routes';
import { routes as siteFeaturesRoutes } from './site-features/routes';
import { routes as contactlessPublicRoutes } from './contactless-public/routes';
import { routes as displayRoutes } from './display/routes';
// Phase 4 (docs/PHASE-4-PLAN.md)
import { routes as securityRoutes } from './security/routes';
import { routes as billingRoutes } from './billing/routes';
import { routes as integrationsRoutes } from './integrations/routes';
import { routes as dataProtectionRoutes } from './data-protection/routes';
import { routes as publicP4Routes } from './public-p4/routes';
import { routes as formsOutlookRoutes } from './forms-outlook/routes';
import { routes as tenantSetupRoutes } from './tenant-setup/routes';
// Phase 5: shared reception (docs/SHARED-RECEPTION-PLAN.md)
import { routes as platformSrRoutes } from './platform-sr/routes';
import { routes as sharedReceptionRoutes } from './shared-reception/routes';
import { routes as buildingRoutes } from './building/routes';

/** Every Phase 1-4 module page, mounted by App.tsx. Each folder is owned by one task. */
export const moduleRoutes: ModuleRoute[] = [
  ...sitesRoutes,
  ...membersRoutes,
  ...fieldsNoticesRoutes,
  ...todayRoutes,
  ...devicesRoutes,
  ...badgesRoutes,
  ...agreementsRoutes,
  ...notificationsRoutes,
  ...preregistrationRoutes,
  ...reportsRoutes,
  ...publicLinksRoutes,
  ...peopleRoutes,
  ...evacuationRoutes,
  ...safetyRoutes,
  ...permitsRoutes,
  ...siteFeaturesRoutes,
  ...contactlessPublicRoutes,
  ...displayRoutes,
  ...securityRoutes,
  ...billingRoutes,
  ...integrationsRoutes,
  ...dataProtectionRoutes,
  ...publicP4Routes,
  ...formsOutlookRoutes,
  ...tenantSetupRoutes,
  ...platformSrRoutes,
  ...sharedReceptionRoutes,
  ...buildingRoutes,
];
